module.exports = "/images/puzzle.svg?d747bb59358d4af4e7f80409bebc0afe";